/**
 * Devedores — contratos com parcelas vencidas (visão investidor).
 */
import { formatCurrency, formatNumber } from '../../../../utils/obraAnalytics'

const DevedoresPanel = ({ devedores = [], montanteTotal = 0, qtdDevedores = 0 }) => {
    if (!devedores.length) {
        return (
            <div className="bg-white border border-gray-100 rounded-2xl shadow-sm overflow-hidden">
                <div className="px-5 py-4 border-b border-gray-100">
                    <h3 className="text-sm font-bold text-gray-800">Em atraso</h3>
                    <p className="text-xs text-gray-400 mt-0.5">Contratos com parcelas vencidas</p>
                </div>
                <div className="p-6 text-center">
                    <p className="text-sm text-gray-400">Nenhum contrato em atraso na carteira.</p>
                </div>
            </div>
        )
    }

    return (
        <div className="bg-white border border-rose-100 rounded-2xl shadow-sm overflow-hidden">
            <div className="px-5 py-4 border-b border-rose-100 bg-rose-50/50 flex flex-wrap items-center justify-between gap-3">
                <div>
                    <h3 className="text-sm font-bold text-rose-900">Em atraso</h3>
                    <p className="text-xs text-rose-700/70 mt-0.5">Todos os contratos com parcelas vencidas</p>
                </div>
                <div className="text-right">
                    <p className="text-[10px] uppercase tracking-wide text-rose-600 font-semibold">
                        {formatNumber(qtdDevedores)} contrato(s)
                    </p>
                    <p className="text-xl font-bold text-rose-700">{formatCurrency(montanteTotal)}</p>
                </div>
            </div>

            <div className="overflow-x-auto">
                <table className="w-full text-sm">
                    <thead className="bg-gray-50 text-gray-500 uppercase tracking-wide text-xs">
                        <tr>
                            <th className="px-4 py-3 text-left">Cliente</th>
                            <th className="px-4 py-3 text-left">Contrato</th>
                            <th className="px-4 py-3 text-right">Parcelas</th>
                            <th className="px-4 py-3 text-left">Venc. mais antigo</th>
                            <th className="px-4 py-3 text-right">Valor em atraso</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-50">
                        {devedores.map((d, i) => (
                            <tr key={`${d.contrato}-${i}`} className="hover:bg-rose-50/30 transition-colors">
                                <td className="px-4 py-3 font-medium text-gray-800">{d.cliente || '—'}</td>
                                <td className="px-4 py-3 text-gray-600 tabular-nums">{d.contrato || '—'}</td>
                                <td className="px-4 py-3 text-right text-gray-600 tabular-nums">
                                    {formatNumber(d.parcelas_vencidas ?? 0)}
                                </td>
                                <td className="px-4 py-3 text-gray-600">{d.vencimento_mais_antigo || '—'}</td>
                                <td className="px-4 py-3 text-right font-semibold text-rose-700 tabular-nums">
                                    {formatCurrency(d.montante_vencido)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default DevedoresPanel
